import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  vaccineContainer: {
    height: '100%',
    position: 'relative',
    paddingRight: 16,

    '& .vaccine-search': {
      display: 'flex',
      alignItems: 'center',
      height: 'auto',
      boxShadow: '0 0 15px 0px rgb(111 72 65 / 0.15)',
      borderRadius: 8,
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      '& p': {
        color: '#513628',
        fontSize: 16,
        margin: '6px 0 0 8px'
      },
      '& i': {
        marginRight: 8,
        border: '0.10em solid #513628',
        borderTop: 'none',
        borderLeft: 'none',
        padding: 4,
        background: '#fff'
      },
      '& input': {
        width: '100%',
        height: 16,
        fontSize: 16,
        margin: '16px 0 8px 8px',
        borderTop: 'none',
        borderLeft: 'none',
        borderRight: 'none',
        border: '0.10em solid #513628',
        '&:focus': {
          outline: 0
        },
      },
      '@media (max-width:1156px)': {
        '& input': {
          width: '75% ',
        },
      }
    },
  },

  vaccineDivider: {
    width: '35%',
    display: 'none',
    marginTop: 8,

    '@media (min-width:356px)': {
      display: 'unset'
    }
  },

  vaccineTableActions: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-around',
    height: 5,
    '& img': {
      cursor: 'pointer',
    },
  },

  vaccinePopup: {
    '& .popup__box': {
      height: 'auto',
    },
  },

  vaccineTitle: {
    width: 100,
    color: theme.palette.primary.main,
    fontSize: theme.app.typography.subTitle.fontSize,
    fontWeight: theme.app.typography.subTitle.fontWeight,
  },

  vaccineHeader: {
    display: 'block',
    width: '100%',
    alignItems: 'center',
    paddingRight: 16,
    '@media (min-width:356px)': {
      paddingRight: 0,
      display: 'inline-flex',
    }
  },

  vaccineButtonContainer: {
    marginLeft: 'auto',
    width: '100%',
    '& button': {
      width: '100%',
      margin: '8px 16px 16px 0',
      '& img': {
        marginRight: 8
      }
    },
    '@media (min-width:356px)': {
      width: 'unset',
      '& button': {
        width: 146,
        margin: '0 16px 0 0',
        '& img': {
          marginRight: 8
        }
      },
    }
  },


  salesHeaderContent: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'start'
    }
  },

  salesHeaderBtnContainer: {
    display: 'flex',
    alignItems: 'center',

    '& :nth-child(2)': {
      width: 139,
      marginLeft: 16
    },

    [theme.breakpoints.down('sm')]: {
      padding: '16px 0',
      flexWrap: 'wrap'
    }
  },

  salesHeader: {
    display: 'block',
    width: '100%',
    alignItems: 'center',
    paddingRight: 16,
    '@media (min-width:356px)': {
      paddingRight: 16,
      display: 'inline-flex'
    }
  },

  buttonContainer: {
    display: 'flex',
    gap: '10px',
    marginBottom: '-2px',
    paddingLeft: '10px',
    zIndex: 1,
    [theme.breakpoints.down('sm')]: {
      paddingLeft: '0',
      marginTop: '8px',
      flexDirection: 'column',
      width: '100%'
    }
  },

  buttonOutlined: {
    backgroundColor: 'transparent',
    border: `1px solid ${theme.palette.primary.main}`,
    color: theme.palette.primary.main
  },

  buttonWrapper: {
    width: 'max-content',
    display: 'flex',
    padding: '8px 16px 8px 12px',
    gap: '8px',

    [theme.breakpoints.down('sm')]: {
      width: '100%',
    }
  },
}))
